import {isEnterprise} from '@github-ui/runtime-environment'
import {testIdProps} from '@github-ui/test-id-props'
import {Button, Stack} from '@primer/react'

import {BlankslateErrorMessage} from './blankslate-error-message'

const clickHandler = () => {
  window.location.reload()
}

export const ProjectErrorFallback: React.FC = () => {
  return (
    <BlankslateErrorMessage
      as="main"
      headingAs="h1"
      heading="This project failed to load"
      content="Sorry about that. Please try refreshing and contact us if the problem persists."
      {...testIdProps('project-error-fallback')}
    >
      <Stack direction="horizontal" align="center" justify="center">
        {isEnterprise() ? null : (
          <Button variant="invisible" as="a" href="https://www.githubstatus.com">
            GitHub Status
          </Button>
        )}
        <Button variant="primary" onClick={clickHandler}>
          Reload
        </Button>
      </Stack>
    </BlankslateErrorMessage>
  )
}
